import React, { FC, ReactChild } from 'react'
import { ThemeProvider } from 'styled-components'
import Box from '@/atoms/Box'
import { graphql } from 'gatsby'
import { SanityModuleDefaultFields } from 'web/types/graphql-types'
import pageTheme, { lightTheme, darkTheme, brandTheme } from '@/styles/theme'

type Props = {
  children: ReactChild | ReactChild[] | JSX.Element,
  options?: SanityModuleDefaultFields | null,
  type?: string;
}

const ModuleContainer: FC<Props> = ({ children, options, type }) => {

  return (
    <ThemeProvider theme={
      options?.theme?.theme === 'none'
        ? { ...pageTheme, colors: { ...pageTheme.colors, brand: options?.theme?.list?.value } }
        : (options?.theme?.theme === 'light'
          ? { ...pageTheme, colors: { ...lightTheme.colors, brand: options?.theme?.list?.value } }
          : (options?.theme?.theme === 'dark'
            ? { ...pageTheme, colors: { ...darkTheme.colors, brand: options?.theme?.list?.value } }
            : {
              ...pageTheme, colors: {
                ...brandTheme.colors,
                background: options?.theme?.list?.value
              }
            }))
    }>
      <Box
        bg={"background"}
        width={ ['100vw', `${options?.padding?.width}vw`] }
        style={{
          scrollSnapAlign: 'start',
        }}
      >
        <Box
          px={options?.padding?.x}
          py={options?.padding?.y}
          pt={`calc(${options?.padding?.y} + 7rem)`}
          pb={`calc(${options?.padding?.y} + 0rem)`}
          mx="auto"
          maxWidth={options?.padding?.container ? pageTheme.containerWidth : ''}
          minWidth={pageTheme.minComponentWidth}
          bg={"background"}
          color={"text"}
          height="100%"
          overflow="hidden"
        >
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  )
}

export default ModuleContainer


export const query = graphql`
 fragment ModuleOptions on SanityModuleDefaultFields {
    activation {
      hidden
    }
    padding {
      width
      x
      y
    }
    theme {
      theme
      list {
        value
        title
      }
    }
 }
`
